<template>
  <hr class="dropdown-divider" />
</template>
<script>
export default {
  name: "BDropdownDivider",
  props: {
    tag: {
      type: String,
      default: "hr",
    },
  },
};
</script>
